import React from 'react'
import Breadcrumb from '../Breadcrumb/Breadcrumb'
import LeaveImpressionAbout from './LeaveImpressionAbout'
import LeadershipAbout from './LeadershipAbout'
import bannerImg from '../../asset/homefour/about.webp';

const About = () => {
  return (
    <div>
      <Breadcrumb
        currentPage="About"
        bannerImage={bannerImg}
      />
      <LeaveImpressionAbout />
      <LeadershipAbout />
    </div>
  )
}

export default About